module.exports = __webpack_public_path__ + "media/images/bindingAccount/icon_succ-8a37bd55f6b49537d953e8c74d159a2d.svg";